import React, { createContext, useState, useContext, useEffect } from "react";
import { auth, onAuthStateChanged } from "../../utils/firebase";

// Create the Context
const AppContext = createContext();

// Create a custom hook to use the context
export const useAppContext = () => {
  return useContext(AppContext);
};

// Create a context provider
export const AppProvider = ({ children }) => {
  const [user, setUser] = useState({})
  const setUserInfo = (userInfo) => {
    setUser(userInfo);
  };

  useEffect(() => {
    onAuthStateChanged(auth, (user)=>{
      setUserInfo(user)
    });
  }, [])

  return (
    <AppContext.Provider value={{ user, setUserInfo }}>
      {children}
    </AppContext.Provider>
  );
};
